// extracted by mini-css-extract-plugin
export var root = "LiveCode-module--root--_Xnoj";
export var preview = "LiveCode-module--preview--3N1YR";
export var bgLayout = "LiveCode-module--bgLayout--3VYIz";
export var center = "LiveCode-module--center--53Uzs";
export var editor = "LiveCode-module--editor--2i603";
export var error = "LiveCode-module--error--i3wMK";